<template>
  <div class="GenitorSV">
    <div class="row">
      <div class="col-12">
        <div class="GenitorSV_header label pb-1 d-flex w-100 justify-content-between align-items-center">
          Genitor {{ propIndexGenitor + 1 }}
          <button class="btn btn-danger btn-sm"
                  @click="removeGenitor()">
            Excluir
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-2">
        <div class="form-group">
          <label class="label"
                 :for="`cpf-${propIndexGenitor}-${propIndexPessoa}`">CPF</label>
          <input :id="`cpf-${propIndexGenitor}-${propIndexPessoa}`"
                 ref="cpf_genitor"
                 v-model="propGenitor.pessoa.cpf"
                 v-validate="{ regex: /\d{3}\.\d{3}\.\d{3}-\d{2}$/ }"
                 v-mask="{ mask: '999.999.999-99' }"
                 :class="{ 'is-invalid': errors.has('cpf') }"
                 class="form-control form-control-sm"
                 name="cpf"
                 placeholder="000.000.000-00"
                 type="tel"
                 @change="searchCPF">
          <small v-if="errors.has('cpf')"
                 class="invalid-feedback">{{ errors.first('cpf') }}</small>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="label"
                 :for="`nomeGenitor-${propIndexGenitor}-${propIndexPessoa}`">Nome do genitor<span class="text-danger"> * </span></label>
          <input :id="`nomeGenitor-${propIndexGenitor}-${propIndexPessoa}`"
                 v-model.lazy="propGenitor.pessoa.nome"
                 v-validate="{ required: true }"
                 v-uppercase
                 :class="{ 'is-invalid': errors.has('nomeGenitor') }"
                 class="form-control form-control-sm text-uppercase"
                 :name="`nomeGenitor-${propIndexGenitor}-${propIndexPessoa}`"
                 placeholder="Manuelina Terebentina"
                 type="text">
          <small v-if="errors.has(`nomeGenitor-${propIndexGenitor}-${propIndexPessoa}`)"
                 class="invalid-feedback">{{ errors.first(`nomeGenitor-${propIndexGenitor}-${propIndexPessoa}`) }}</small>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group">
          <label class="label"
                 for="sexoGenitor">Sexo <span class="text-danger"> * </span></label>
          <select id="sexoGenitor"
                  v-model="propGenitor.pessoa.sexo"
                  v-validate="{ required: true }"
                  :class="{ 'is-invalid': errors.has('sexoGenitor') }"
                  class="custom-select custom-select-sm"
                  name="sexoGenitor">
            <small v-if="errors.has('sexoGenitor')"
                   class="invalid-feedback">{{ errors.first('sexoGenitor') }}</small>
            <option selected
                    value="">
              Selecione
            </option>
            <option v-for="sex in SEXOS"
                    :key="sex.value"
                    :value="sex.value">
              {{ sex.name }}
            </option>
          </select>

          <small v-if="errors.has('sexoGenitor')"
                 class="invalid-feedback">{{ errors.first('sexoGenitor') }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import PessoasService from "@/services/Pessoas"

  /* filters */
  import { filterDate, filterMaskedNumber, maskCPF } from '@/filters/filters'

  /* libraries */
  import moment from "moment"

  /* constants */
  import BrazilianStates from "@/constants/brazilianStates"
  import SEXOS from "@/constants/sexos"
  import Cidades from "@/constants/repositorio/cidades"
  
  export default {
    name: 'GenitorSV',
    props: {
      propGenitor: { type: Object, default: () => ({})},
      propIndexPessoa: { type: Number, default: 0},
      propIndexGenitor: { type: Number, default: 0}
    },
    inject: ['$validator'],
    data () {
      return {
        selectsOptions: {
          states: [...BrazilianStates],
          cities: []
        },
        citiesFiltered: [],
        SEXOS,
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD')
      }
    },
    computed: {
      sexo () {
        if (this.propGenitor.pessoa.sexo && this.propGenitor.pessoa.sexo == 'F') return 'nome_feminino'

        return 'nome_masculino'
      }
    },
    mounted () {
      this.getDados()
    },
    methods: {
      getDados () {
        if (this.propGenitor.pessoa.uf) this.ufChanged(this.propGenitor.pessoa.uf)

        if (!this.propGenitor.filiacao || !this.propGenitor.filiacao.length) {
          this.propGenitor.filiacao = [
            {nome: ''},
            {nome: ''}
          ]
        }

        if (this.propGenitor.filiacao.length === 1) {
          this.propGenitor.filiacao.push({nome: ''})
        }

        if (!this.propGenitor.localOcorrenciaFalecimento) {
          this.propGenitor.localOcorrenciaFalecimento = {
            tipo: 'OUTRO',
            endereco: {}
          }
        }

        if (this.propGenitor.pessoa.cpf) this.propGenitor.pessoa.cpf = maskCPF(this.propGenitor.pessoa.cpf)
      },
      async searchCPF () {
        let cpf = filterMaskedNumber(this.propGenitor.pessoa.cpf)

        if (cpf && cpf.length > 10) {
          const dados = await PessoasService.getPessoaByCPF(cpf)

          if (dados.isEmpty) return

          const { nome, datanascimento, sexo, nomemae } = dados
          const sexos = {
            1: 'M',
            2: 'F'
          }

          if (nomemae && (!this.propGenitor.filiacao.length || !this.propGenitor.filiacao[0].nome)) {
            this.propGenitor.filiacao[0].nome = nomemae
          }

          this.propGenitor.pessoa.nome = nome

          let dataNascimento = filterDate(datanascimento)

          this.propGenitor.pessoa.data_nascimento = dataNascimento.split('/').reverse().join('-')

          if ((sexos[sexo] === 'F' || sexos[sexo] === 'M') && (this.propNascimento)) {
            this.propGenitor.pessoa.sexo = sexos[sexo]
          }


        }

        this.propGenitor.pessoa.cpf = this.propGenitor.pessoa.cpf || null
      },
      nascimentoHandler () {
        if (!this.propGenitor.pessoa.data_nascimento) {
          this.propGenitor.pessoa.data_nascimento = null
          this.propGenitor.pessoa.idade = 0
        }
      },
      async ufChanged (uf) {
        if (!uf) {
          this.propGenitor.pessoa.naturalidade = null
          return
        }
        this.citiesFiltered = []

        for (let state of this.selectsOptions.states) {
          if (state.uf == uf) {
            this.propGenitor.pessoa.uf = state.uf
            this.citiesFiltered = Cidades.filter(cidade => cidade.uf == state.uf)

            break
          }
          
          if (state.uf == 'EX') {
            this.propGenitor.pessoa.naturalidade = 'Outro'
          }
        }
      },
      updateProfissao (profissao = {}) {
        this.propGenitor.pessoa.ocupacao = profissao
        this.propGenitor.pessoa.ocupacao_codigo = profissao.codigo
      },
      changeNacionalidade (nacionalidade) {
        this.formGenitor.pessoa.nacionalidade = nacionalidade
      },
      removeGenitor () {
        this.$emit('removeGenitor')
      }
    }
  }
</script>

<style lang="scss">
  .GenitorSV {
    &_header {
      border-bottom: 1px solid #858585 ;
    }
  }



  .btn-new-genitor:hover > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
